import { fetchV1 } from 'helpers/fetch.js';
import { toQueryString } from 'helpers/api.js';

export default {
  getTrendingBrands(filters) {
    return fetchV1.get(`/trending_brands?${toQueryString(filters)}`);
  },
  getBrandMetadata(id) {
    return fetchV1.get(`/brands/${id}`);
  },
  getBrandsList(filter) {
    return fetchV1.get(`/brands?${toQueryString(filter)}`);
  },
  getCompetitorsBrands(filters) {
    return fetchV1.get(`/competitor_brands?${toQueryString(filters)}`);
  },
  getSubscribedBrands(filters) {
    return fetchV1.get(`/subscribed_brands?${toQueryString(filters)}`);
  },
  getBookmarkedBrands(filters) {
    return fetchV1.get(`/bookmarked_brands?${toQueryString(filters)}`);
  },
  getPublishersBrands(entityId, filter) {
    return fetchV1.get(`/publishers/${entityId}/brands?${toQueryString(filter)}`);
  },
  getPublishersBrandsInsights(entityId, filter) {
    return fetchV1.get(`/publishers/${entityId}/brands_insights?${toQueryString(filter)}`);
  },
};
